<app-data-table title="Competitors"
                [columns]="columns"
                [fetchDataFn]="loadData"
                [exportDataFn]="exportData"
                [reloadEmitter]="reloadTable$"
                [enableGlobalSearch]="true"
                [loading]="loading"
                [globalFilterFields]="['agency_name', 'competitor_mapped', 'agency_type']"
                globalSearchPlaceholder="Search by competitor, mapped competitor, entity type"
                defaultSortField="agency_name"
                [exportable]="authService.hasPermission('competitor_mappings.competitor_mappings.export')">
</app-data-table>
